import { RECORDS_PDF_REDACTION_KEYWORD_CATEGORIES } from './recordsPdfRedactionKeywords'

export type RecordsPdfRedactionRule = {
  id: string
  label: string
  phrases: readonly string[]
}

export type RecordsPdfRedactionCategory = {
  id: string
  label: string
  rules: readonly RecordsPdfRedactionRule[]
}

// Phrase matching is case-insensitive, so capitalization variants do not need separate entries.
export const RECORDS_PDF_REDACTION_CATEGORIES: readonly RecordsPdfRedactionCategory[] =
  RECORDS_PDF_REDACTION_KEYWORD_CATEGORIES.map(({ id: categoryId, label, keywords }) => ({
    id: categoryId,
    label,
    rules: keywords.map((keyword, index) => ({
      id: `${categoryId}-${index}`,
      label: keyword,
      phrases: [keyword],
    })),
  }))

export const RECORDS_PDF_REDACTION_RULES: readonly RecordsPdfRedactionRule[] = RECORDS_PDF_REDACTION_CATEGORIES.flatMap(
  ({ rules }) => rules,
)

export const RECORDS_PDF_REDACTION_KEYWORDS: readonly string[] = RECORDS_PDF_REDACTION_RULES.flatMap(
  ({ phrases }) => phrases,
)

export const getRecordsPdfRedactionKeywords = (selectedRuleIds: ReadonlySet<string>): readonly string[] =>
  RECORDS_PDF_REDACTION_RULES.filter(({ id }) => selectedRuleIds.has(id)).flatMap(({ phrases }) => phrases)
